import pickBy from "lodash/pickBy";

import { DeskCollectionFilter } from "../../graphql/generated.ts";
import { getDateTimeRangeFilter } from "../../utils/filter.ts";
import { DeskCollectionDashboardFilterValue } from "./types.ts";

export const getDeskCollectionDashboardApiFilter = (
  value: DeskCollectionDashboardFilterValue
): DeskCollectionFilter => {
  return pickBy({
    customerId: value.customerId?.length && { in: value.customerId },
    collectionDate: value.collectionDate
      ? getDateTimeRangeFilter(value.collectionDate)
      : { not: null },
  });
};
